


















































































































import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import {
    IDictionary,
    IFormControl,
    IListItem,
    ISite,
    GroupBy,
    DateRangeMapper,
    ISaleLogsModel,
    ISaleLogsItemModel, ISort
} from '../../../entities';
import { AgentOfficeCriteria } from '../../../components/criteria/agent-office-criteria';
import * as types from '../../../store/types';
import sitesApi from '@/api/sites.api';
import typesApi from '@/api/site-types.api';
// import { ISite } from '@/entities/sites/site.interface';
// import * as types from '@/store/types';
import { mapGetters } from 'vuex';
import queryService from '@/services/query.service';

import {
    createBigPeriodListItems,
    parsePeriodListItem,
    parseDate,
    formatDate
} from '../../../utils';

const initTypes: IListItem[] = [{ heading: 'All', value: null }];

export interface ISaleLogsCriteria {
    siteId: number | null;
    companyId: number | null;
    agentId: number | null;
    recordType: number | null;
    clickId: number | null;
    email: string | null;
    geo: string | null;
    start: string;
    end: string;
}

@Component(
  {
      computed: mapGetters({
        adminPermissions: types.AUTH_HAS_ADMIN_PERMISSIONS
    })
  }
)
export default class SaleLogsCriteriaComponent extends AgentOfficeCriteria {
    @Prop() public masterLoading: boolean = false;
    public dateRangeHints: IListItem[] = [
        { heading: 'Choose payout period', value: null },
        ...createBigPeriodListItems()
    ];
    public formState: IDictionary<IFormControl> = this.createFormState();

    public sites: IListItem[] = [{ heading: 'All Sites', value: null }];
    public sitesInProgress: boolean = false;
    public adminPermissions: boolean;

    public async created() {
        super.created();

        this.sitesInProgress = true;
        try {
            const withSuspended = this.adminPermissions;
            const items = await sitesApi.list(withSuspended);
            const mapped: IListItem[] = items.map((x) => {
                return { value: x.id, heading: x.sitename };
            });
            this.sites = [{ heading: 'All Sites', value: null }, ...mapped];
        } finally {
            this.sitesInProgress = false;
        }

        this.doSearch();
    }

    public defaultFormValues(): IDictionary<any> {
        return {
            siteId: null,
            companyId: this.getDefaultOrNullOfficeId(),
            agentId: this.getDefaultOrNullAgentId(),
            recordType: this.getDefaultOrNullRecordType(),
            dateRange: this.getDefaultDateRange()
        };
    }

    public createFormState(): IDictionary<IFormControl> {
        const defValues = this.defaultFormValues();
        return {
            siteId: {
                key: 'siteId',
                label: 'Site',
                value: defValues['siteId']
            },
            companyId: {
                key: 'companyId',
                label: 'Office',
                value: defValues['companyId']
            },
            agentId: {
                key: 'agentId',
                label: 'Agent',
                value: defValues['agentId']
            },
            recordType: {
                key: 'recordType',
                label: 'Record type',
                value: defValues['recordType']
            },
            dateRange: {
                key: 'dateRange',
                label: 'Date',
                value: defValues['dateRange'],
                mapper: DateRangeMapper
            },
            clickId: {
                key: 'clickId',
                label: 'Click ID',
                value: null,
            },
            rawSiteId: {
                key: 'rawSiteId',
                label: 'Site ID',
                value: null,
            },
            rawAgentId: {
                key: 'rawAgentId',
                label: 'Agent ID',
                value: null,
            },
            email: {
                key: 'email',
                label: 'Email (exact)',
                value: null,
            },
            geo: {
                key: 'geo',
                label: 'Geo (exact)',
                value: null,
            },
        };
    }

    public getQueryObject(
        formState: IDictionary<IFormControl>
    ): ISaleLogsCriteria {
        return {
            siteId: formState.rawSiteId.value ? Number(formState.rawSiteId.value) : formState.siteId.value,
            companyId: formState.companyId.value,
            agentId: (formState.rawAgentId.value) ? Number(formState.rawAgentId.value) : formState.agentId.value,
            recordType: formState.recordType.value,
            start: formatDate(formState.dateRange.value.start),
            end: formatDate(formState.dateRange.value.end),
            clickId: (formState.clickId.value) ? Number(formState.clickId.value) : null,
            email: formState.email.value,
            geo: formState.geo.value,
        };
    }

    @Emit()
    public search(body: any) {
        this.saveDateRange({
            start: body.start,
            end: body.end
        });
    }

    @Watch('$route')
    private onRouteChanged(val: string, oldVal: string) {
        this.doSearch();
    }

    @Watch('formState.companyId.value')
    private onCompanyIdChanged(val: string, oldVal: string) {
        this._reloadAgents(this.formState.companyId.value);
    }

    @Watch('formState.rawSiteId.value')
    private onRawSiteIdChanged(val: string, oldVal: string) {
        this.formState.siteId.value = val ? val : null;
    }

    @Watch('formState.rawAgentId.value')
    private onRawAgentIdChanged(val: string, oldVal: string) {
        this.formState.agentId.value = val ? val : null;
    }
}
